/**
 * All Loot API traffic goes through the BFF proxy (/api/loot/v1/*), which
 * injects the tenant's publishable key server-side. The browser never holds a
 * key, so the client is constructed with this placeholder — the BFF overwrites
 * the header on every request.
 */
export const LOOT_PROXY_BASE = "/api/loot";
export const PROXIED_PUBLISHABLE_KEY = "proxied";
